import { useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import { abnjSso } from '../sso';
import { deleteCookie, getCookie } from '../utils/cookies';

// /callback: every njjamaat.org app has this page (copy it as-is), and its URL is
// registered as the app's redirect_url in backend/allowed-origins.js. After sign-in,
// the sign-in page sends the user here.
//
//   1. wait for AuthContext's session check (it runs once on every page load, so no
//      second /verify-session call is needed here)
//   2. go to the page the user started from (redirect_after_login, saved by signIn()),
//      but only if it's on this app's origin; otherwise "/". This is a full page load,
//      not a React Router navigate(): the page may belong to another app served on the
//      same origin (e.g. njjamaat.org/link/admin, a Worker), which this site's router
//      doesn't know and would show as a blank page.
export default function Callback() {
  const { authChecked, isAuthenticated } = useAuth();

  useEffect(() => {
    if (!authChecked) return; // AuthContext's session check is still running

    if (isAuthenticated) {
      const saved = new URL(getCookie('redirect_after_login') || '/', window.location.origin);
      deleteCookie('redirect_after_login');
      window.location.replace(saved.origin === window.location.origin ? saved.href : '/');
    } else {
      // Not signed in after all: start over, coming back to this app's home page.
      abnjSso.signIn('/');
    }
  }, [authChecked, isAuthenticated]);

  // Show loading placeholder while session verification is in-flight
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100 px-4">
      <div className="text-center text-gray-700">Verifying session...</div>
    </div>
  );
}
